module.exports = __webpack_public_path__ + "img/7c5aac8baf544f6807fb2dee4cab5b87.svg";